import { secureDelete, secureGet, securePost, securePut } from "../../Config/ApiConfig";


export const getknowledgeDatabases = async ({ page, size, search }) => {
    const { data } = await secureGet('/knowledge-bases?page=' + page + '&per_page=' + size + (search ? "&search_string=" + search : ''))
    return data;
};


export const getKnowledgeDatabase = async (id) => {
    const { data } = await secureGet('/knowledge-bases/' + id);
    return data;
};


export const getEntries = async (id, page) => {
    const { data } = await secureGet('/knowledge-bases/' + id + '/entries?page=' + page);
    return data;
};

export const addKnowledgeDatabase = async ({ name, description }) => {
    const { data } = await securePost('/knowledge-bases', { name, description });
    return data;
};

export const updateKnowledgeDatabase = async ({ name, description, id }) => {
    const { data } = await securePut(`/knowledge-bases/${id}`, { id, name, description });
    return data;
};

export const createOrUpdateQAEntry = async ({ id, knowledge_base_id, question, answer }) => {
    const url = id ? '/knowledge-bases/qa-entries/' + id : '/knowledge-bases/' + knowledge_base_id + '/qa-entries';
    const { data } = (id
        ? await securePut(url, { question, answer })
        : await securePost(url, { question, answer }));
    return data;
};

export const createOrUpdateBusinessInfoEntry = async ({ id, knowledge_base_id, content }) => {
    const url = '/knowledge-bases/' + knowledge_base_id + '/info-entries';
    const { data } = (id
        ? await securePut(url, { content })
        : await securePost(url, { content }));
    return data;
};

export const deleteKnowledgeBase = async (id) => {
    const url = '/knowledge-bases/' + id;
    const { data } = await secureDelete(url);
    return data;
};
export const deleteEntry = async (id) => {
    const url = '/knowledge-bases/entries/' + id;
    const { data } = await secureDelete(url);
    return data;
};
